import React, { useContext, useEffect, useState } from "react";

import { Preview } from "@creatomate/preview";

import { Organization, Template as Templates } from "chq";
import { useProfile } from "app/context";
import { aspectRatioMap } from "app/utils/constants";

import { getImageTemplatesByOrg } from "components/stories/video-studio/utils";
import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";
import setTemplate from "components/stories/video-studio/utils/creatomate/setTemplate";

import ImageCard from "./image-card/ImageCard";
import { defaultImageTemplates } from "./templates";

interface ImageTemplatesProps {
  preview: Preview;
}

const ImageTemplates: React.FC<ImageTemplatesProps> = ({ preview }) => {
  const { data, handleUpdateData } = useContext(CreatomateContext);
  const { mediaType, selectedTemplate, story } = data;

  const { profile: { organization } } = useProfile();

  const [imageTemplatesToUse, setImageTemplatesToUse] = useState<Templates[]>(
    defaultImageTemplates
  );

  useEffect(
    () => {
      setImageTemplatesToUse(getImageTemplatesByOrg(organization.name || ""));
    }, [organization]
  );

  const getAspectRatio = (template: Templates): string => {
    const key = `${template.width}x${template.height}`;
    return aspectRatioMap[key] || "wide-landscape";
  };

  const handleSelectedTemplate = (template: Templates) => {
    handleUpdateData({
      aspectRatioStringValue: getAspectRatio(template),
      selectedTemplate: template
    });
    getAspectRatio(template);
    setTemplate(
      handleUpdateData,
      preview,
      organization as Organization,
      mediaType,
      [],
      story,
      template
    );
  };

  return (
    <>
      {imageTemplatesToUse.map(template => (
        <ImageCard
          key={template.value}
          template={template}
          onSelectedTemplate={handleSelectedTemplate}
          selectedTemplate={selectedTemplate}
        />
      ))}
    </>
  );
};

export default ImageTemplates;
